export default {
  title: "Suporte",
  payments: "Para todas as questões relacionadas a pagamentos, envie um e-mail para {finance_email}.",
  spam: 'Importante: verifique a pasta de "Spam"!',
  other: "Para todas as outras questões, utilize o formulário abaixo.",
  faq: "perguntas frequentes",
  faq_notice:
    "Antes de enviar uma solicitação, revise nossas regras e a seção de {faq} (FAQ) — a resposta pode já estar lá.",
  response_time:
    "A resposta pode levar de 12 horas a 2 dias úteis, dependendo da complexidade da solicitação e da carga atual do suporte."
};
